"use strict";
var randomBuffer = new Uint16Array(1);
/**
 * Returns a random number on [0, 1)
 * Uses window.crypto if available
 */
function rand() {
    if (typeof crypto !== "undefined") {
        crypto.getRandomValues(randomBuffer);
        return randomBuffer[0] / Math.pow(2, 16);
    }
    else {
        return Math.random();
    }
}
var UUID = {
    /**
     * Generates a v4 UUID.
     */
    get: function () {
        var template = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
        var value = template.replace(/[xy]/g, function (c) {
            var v = Math.floor(rand() * 16);
            if (c !== "x") {
                v = v & 0x3 | 0x8;
            }
            return v.toString(16);
        });
        return value;
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UUID;

//# sourceMappingURL=UUID.js.map
